var __vue_exports__, __vue_options__

/* script */
__vue_exports__ = require("!!babel-loader!vue-loader/lib/selector?type=script&index=0!./info_delegateregistration.vue")

/* template */
var __vue_template__ = require("!!vue-loader/lib/template-compiler?id=data-v-7!vue-loader/lib/selector?type=template&index=0!./info_delegateregistration.vue")
__vue_options__ = __vue_exports__ = __vue_exports__ || {}
if (
  typeof __vue_exports__.default === "object" ||
  typeof __vue_exports__.default === "function"
) {
__vue_options__ = __vue_exports__ = __vue_exports__.default
}
if (typeof __vue_options__ === "function") {
  __vue_options__ = __vue_options__.options
}
__vue_options__.render = __vue_template__.render
__vue_options__.staticRenderFns = __vue_template__.staticRenderFns

module.exports = __vue_exports__



/*****************
 ** WEBPACK FOOTER
 ** ./src/components/info_delegateregistration.vue
 ** module id = 74
 ** module chunks = 2
 **/